import { useMutation } from 'react-query';

import { deleteChapter } from '../infrastructure/delete-chapter';
import { useInvalidateAllChapters } from './utils/invalidate-all-chapters';

export const useDeleteChapterMutation = () => {
    const invalidateAll = useInvalidateAllChapters();

    return useMutation({
        mutationFn: deleteChapter,
        onSuccess: () => {
            invalidateAll();
        },
    });
};
